import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove crawler-only prerender content before React mounts so users never see it
const prerender = document.getElementById("prerender-content");
if (prerender) prerender.remove();

createRoot(document.getElementById("root")!).render(<App />);
